import dataStorage from '../misc/data-storage';
import platforms from '../misc/platforms';
import ResponseBody from './ResponseBody';

export default class ResponseHandler {
  // Each app should have its own error codes.
  constructor(context, responseErrors) {
    this.context = context;
    this.responseErrors = responseErrors;
  }

  // PUBLIC
  async handleFetchPromise(fetchPromise) {
    try {
      const response = await fetchPromise; // Network-level success.

      // When success, the server should have always returned a json object.
      const responseBody = new ResponseBody(await response.json());
      if (responseBody.isSuccess()) { // Service-level success.
        return responseBody; // Resolve with the response body.
      } else { // Service-level failure.
        throw responseBody; // Reject with the response body.
      }
    } catch (err) {
      if (err instanceof ResponseBody) {
        // Service-level failure.
        this._handleOnServiceFailure(err);
      } else {
        // Network-level failure.
        this._handleOnNetworkFailure(err);
      }
      throw err; // Continue reject.
    }
  }

  _handleOnServiceFailure(responseBody) {
    if (responseBody.getErrorCode() === this.responseErrors.ERROR_CODES.INVALID_TOKEN) {
      // The login token is already invalid, clear it.
      dataStorage.clearCredential();

      this._showErrorMsg(this.responseErrors.translateErrorCode(responseBody));
      setTimeout(() => {
        this._navigateToLogin();
      }, 1500);
    } else if (responseBody.getErrorCode() === this.responseErrors.ERROR_CODES.UNAUTHORIZED) {
      if (!dataStorage.hasCredential()) {
        this._showErrorMsg(this.responseErrors.translateErrorCode(responseBody));
        setTimeout(() => {
          this._navigateToLogin();
        }, 1500);
      } else {
        this._showErrorMsg(this.responseErrors.translateErrorCode(responseBody));
      }
    } else {
      // Show an error message on screen.
      this._showErrorMsg(this.responseErrors.translateErrorCode(responseBody));
    }
  }

  _handleOnNetworkFailure(err) {
    // Show an error message on screen.
    this._showErrorMsg(`Failed to connect to server, error details: ${err}`);
  }

  _showErrorMsg(msg) {
    this.context.notifyError('Error', msg);
  }

  // Navigates to the login screen or page.
  _navigateToLogin() {
    const webViewBridge = platforms.getClientWebViewBridge();

    if (webViewBridge) {
      webViewBridge.navigate('LOGIN');
    } else {
      window.location = `/login?from=${encodeURIComponent(location.pathname + location.search + location.hash)}`;
    }
  }
}
